import React from 'react';
import { useUi } from '../../context/UiContext';
import { useLanguage } from '../../context/LanguageContext';
import { X, Sparkles } from 'lucide-react';

export const AiAssistantModal: React.FC = () => {
  const { isAiCopilotOpen, setIsAiCopilotOpen } = useUi();
  const { t } = useLanguage();
  if (!isAiCopilotOpen) return null;
  return (
    <div className="fixed inset-0 z-50 bg-ink/55 backdrop-blur-[2px] flex items-center justify-center p-4">
      <div className="relative w-full max-w-md overflow-hidden rounded-lg bg-white dark:bg-ink-elevated border border-line dark:border-line-dark p-5 pt-6 space-y-3 shadow-[var(--bc-shadow-md)] before:absolute before:inset-x-0 before:top-0 before:h-0.5 before:bg-brand-500">
        <div className="flex justify-between items-center">
          <h2 className="font-display text-base font-bold text-ink dark:text-paper flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-brand-500" strokeWidth={1.75} /> {t('ai.title')}
          </h2>
          <button type="button" onClick={() => setIsAiCopilotOpen(false)} className="bc-btn-ghost !p-2">
            <X className="w-4 h-4 text-brand-500" strokeWidth={1.75} />
          </button>
        </div>
        <p className="text-xs leading-relaxed text-fog">{t('ai.modalBody')}</p>
      </div>
    </div>
  );
};
